import { BrowserRouter } from "react-router-dom";
import { Notifications } from "@mantine/notifications";
import AppRoutes from "./routes";
import { NOTIFICATION_AUTO_CLOSE_MS } from "@/shared/constants/notification.const";
import { UserProvider } from "@/context/UserContext";
import { NotificationProvider } from "@/context/NotificationContext";
import { CollaborationHelpProvider } from "@/context/CollaborationHelpContext";
import GtsetuHelpFloatingBot from "@/components/help/GtsetuHelpFloatingBot";
import { ScrollToTop } from "./components/ScrollToTop";
import { useEffect, useState } from "react";
import OfflinePage from "./pages/offline/OfflinePage";

// Mantine theme configuration
function App() {
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!isOnline) {
    return <OfflinePage />;
  }

  return (
    <>
      <Notifications position="top-right" zIndex={1000} autoClose={NOTIFICATION_AUTO_CLOSE_MS} />
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <UserProvider>
          <NotificationProvider>
            <CollaborationHelpProvider>
              <ScrollToTop />
              <AppRoutes />
              <GtsetuHelpFloatingBot />
            </CollaborationHelpProvider>
          </NotificationProvider>
        </UserProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
